// extracted by mini-css-extract-plugin
module.exports = {"container":"Spinner_container__1z2IZ","loader":"Spinner_loader__16F2Y","load4":"Spinner_load4__1-oHr"};